import styled from 'styled-components';
import { IProductImage } from '../../../../../interfaces/Product.interfaces';

interface IProductSeparatedThumbnailImageProps {
  productImages: IProductImage[];
}

export const ProductSeparatedThumbnailImage = ({ productImages }: IProductSeparatedThumbnailImageProps) => {
  return (
    <Container id={'product-separated-thumbnail-image'}>
      <TopSection>
        <ProductImageWrapper>
          <ProductImage imageUrl={productImages[0].imageUrl} />
        </ProductImageWrapper>
      </TopSection>
      <BottomSection>
        <ProductImageWrapper>
          <ProductImage imageUrl={productImages[1]?.imageUrl} />
        </ProductImageWrapper>
        <ProductImageWrapper>
          <ProductImage imageUrl={productImages[2]?.imageUrl} />
        </ProductImageWrapper>
      </BottomSection>
    </Container>
  );
};

const Container = styled.div`
  visibility: hidden;

  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
  flex: 1 0 0;
  align-self: stretch;
  z-index: 2;

  background-color: #fff;
`;

const TopSection = styled.div`
  min-height: 160px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
`;

const BottomSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--radius-small, 4px);
  flex: 1 0 0;
  align-self: stretch;
`;

const ProductImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;

  border-radius: var(--radius-small, 4px);

  overflow: hidden;
`;

const ProductImage = styled.div<{ imageUrl: string }>`
  flex: 1 0 0;
  align-self: stretch;

  background: ${(props) => props.imageUrl && `url(${props.imageUrl}) lightgray 50% / cover no-repeat;`};
`;
